export default "__VITE_ASSET__CyBZZmXx__"